(() => {
  const init = root => {
    root.querySelectorAll('product-info.sakaza-pdp').forEach(info => {
      if (info.querySelector(':scope .sk-pdp-purchase')) return;
      const quantity = info.querySelector('[id^="Quantity-Form-"]');
      const buttons = info.querySelector('.sk-pdp-buy-buttons');
      if (!quantity || !buttons) return;
      const purchase = document.createElement('div');
      purchase.className = 'sk-pdp-purchase';
      quantity.before(purchase);
      purchase.append(quantity, buttons);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
